// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400..900;1,400..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-parent-wrapper-psp {
  width: 100%;
  box-shadow: 0px -6px 31px 0px rgba(0, 0, 0, 0.1215686275);
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  z-index: 9999;
  background-color: #fff;
}
.navbar-parent-wrapper-psp .navbar-content-wrapper-psp {
  width: 100%;
  max-width: 1440px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}
.navbar-parent-wrapper-psp .navbar-content-wrapper-psp svg {
  margin: 16px 0;
}
.navbar-parent-wrapper-psp .navbar-content-wrapper-psp .navbar-routes-wrapper-psp {
  display: flex;
  align-items: center;
  gap: 40px;
}
.navbar-parent-wrapper-psp .navbar-content-wrapper-psp .navbar-routes-wrapper-psp a {
  font-family: "Playfair Display", serif !important;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  color: #000;
}
.navbar-parent-wrapper-psp .navbar-content-wrapper-psp .navbar-routes-wrapper-psp a:first-child {
  display: flex;
  align-items: center;
  gap: 6px;
}
.navbar-parent-wrapper-psp .navbar-content-wrapper-psp .navbar-routes-wrapper-psp a:first-child svg {
  animation: rotate 2s infinite linear;
}
.navbar-parent-wrapper-psp .navbar-content-wrapper-psp .navbar-buttons-wrapper-psp {
  display: flex;
  align-items: center;
  gap: 12px;
}
.navbar-parent-wrapper-psp .navbar-content-wrapper-psp .navbar-buttons-wrapper-psp a {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 22px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
}
.navbar-parent-wrapper-psp .navbar-content-wrapper-psp .navbar-buttons-wrapper-psp a:first-child {
  background-color: #93288E;
  color: #fff;
}
.navbar-parent-wrapper-psp .navbar-content-wrapper-psp .navbar-buttons-wrapper-psp a:nth-child(2) {
  padding: 9px 22px;
  color: #93288E;
  border: 2px solid #93288E;
}
.navbar-parent-wrapper-psp .navbar-content-wrapper-psp .navbar-buttons-wrapper-psp span.disappear {
  display: none;
}
.navbar-parent-wrapper-psp .navbar-slider-close {
  transform: translateX(260px);
}
.navbar-parent-wrapper-psp .navbar-slider-open {
  transform: translateX(0px);
}
.navbar-parent-wrapper-psp .navbar-slider {
  display: none;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 260px;
  height: 100vh;
  margin-top: 72px;
  background-color: #fff;
  z-index: 9999;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.201);
  transition: transform 0.5s ease-in-out;
}
.navbar-parent-wrapper-psp .navbar-slider .navbar-routes-wrapper-psp {
  display: flex;
  flex-direction: column;
}
.navbar-parent-wrapper-psp .navbar-slider .navbar-routes-wrapper-psp a {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Playfair Display", serif !important;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  color: #000;
  padding: 12px 16px;
}
.navbar-parent-wrapper-psp .navbar-slider .navbar-routes-wrapper-psp a:hover {
  background-color: rgba(147, 40, 142, 0.0823529412);
}
.navbar-parent-wrapper-psp .navbar-slider .navbar-routes-wrapper-psp a:first-child {
  gap: 6px;
}
.navbar-parent-wrapper-psp .navbar-slider .navbar-routes-wrapper-psp a:first-child svg {
  animation: rotate 2s infinite linear;
}
.navbar-parent-wrapper-psp .navbar-slider .navbar-buttons-wrapper-psp {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
  padding: 0 16px;
}
.navbar-parent-wrapper-psp .navbar-slider .navbar-buttons-wrapper-psp a {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 22px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
}
.navbar-parent-wrapper-psp .navbar-slider .navbar-buttons-wrapper-psp a:first-child {
  background-color: #93288E;
  color: #fff;
}
.navbar-parent-wrapper-psp .navbar-slider .navbar-buttons-wrapper-psp a:nth-child(2) {
  padding: 9px 22px;
  color: #93288E;
  border: 2px solid #93288E;
}
.navbar-parent-wrapper-psp .navbar-slider .navbar-buttons-wrapper-psp span.disappear {
  display: none;
}
.navbar-parent-wrapper-psp .navbar-slider-overlay {
  display: none;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  z-index: 999;
  transition: opacity 0.3s ease;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media only screen and (width <= 1024px) {
  .navbar-parent-wrapper-psp .navbar-content-wrapper-psp .navbar-routes-wrapper-psp.disappear {
    display: none;
  }
  .navbar-parent-wrapper-psp .navbar-content-wrapper-psp .navbar-buttons-wrapper-psp span.disappear {
    display: inline-block;
  }
  .navbar-parent-wrapper-psp .navbar-slider {
    display: inline-block;
  }
  .navbar-parent-wrapper-psp .navbar-slider .navbar-buttons-wrapper-psp {
    display: none;
  }
  .navbar-parent-wrapper-psp .navbar-slider-overlay.open {
    display: block;
    opacity: 0.5;
    margin-top: 72px;
  }
}
@media only screen and (width <= 576px) {
  .navbar-parent-wrapper-psp .navbar-content-wrapper-psp .navbar-buttons-wrapper-psp a.disappear {
    display: none;
  }
  .navbar-parent-wrapper-psp .navbar-slider .navbar-buttons-wrapper-psp {
    display: flex;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/PaymentStatusPage/components/NavbarPSP/style.scss"],"names":[],"mappings":"AAEA;EACI,WAAA;EACA,yDAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,MAAA;EACA,aAAA;EACA,sBAAA;AAAJ;AACQ;EACI,WAAA;EACA,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AACZ;AACY;EACI,cAAA;AAChB;AAEY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAAhB;AAEgB;EACI,iDAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;AAApB;AAGgB;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AADpB;AAGoB;EACI,oCAAA;AADxB;AAMY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAJhB;AAMgB;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AAJpB;AAOgB;EACI,yBAAA;EACA,WAAA;AALpB;AAQgB;EACI,iBAAA;EACA,cAAA;EACA,yBAAA;AANpB;AAUoB;EACI,aAAA;AARxB;AAcQ;EACI,4BAAA;AAZZ;AAeQ;EACI,0BAAA;AAbZ;AAgBQ;EACI,aAAA;EACA,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,yCAAA;EACA,sCAAA;AAdZ;AAgBY;EACI,aAAA;EACA,sBAAA;AAdhB;AAgBgB;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iDAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;AAdpB;AAeoB;EACI,kDAAA;AAbxB;AAiBgB;EACI,QAAA;AAfpB;AAiBoB;EACI,oCAAA;AAfxB;AAoBY;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;AAlBhB;AAoBgB;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AAlBpB;AAqBgB;EACI,yBAAA;EACA,WAAA;AAnBpB;AAsBgB;EACI,iBAAA;EACA,cAAA;EACA,yBAAA;AApBpB;AAwBoB;EACI,aAAA;AAtBxB;AA4BQ;EACI,aAAA;EACA,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,UAAA;EACA,YAAA;EACA,6BAAA;AA1BZ;;AA8BA;EACI;IACE,uBAAA;EA3BJ;EA6BE;IACE,yBAAA;EA3BJ;AACF;AA8BE;EAIc;IACI,aAAA;EA/BlB;EAqCkB;IACI,qBAAA;EAnCtB;EAyCM;IACI,qBAAA;EAvCV;EAwCU;IACI,aAAA;EAtCd;EA2CU;IACI,cAAA;IACA,YAAA;IACA,gBAAA;EAzCd;AACF;AA8CE;EAKkB;IACI,aAAA;EAhDtB;EAuDU;IACI,aAAA;EArDd;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400..900;1,400..900&display=swap');\n\n.navbar-parent-wrapper-psp{\n    width: 100%;\n    box-shadow: 0px -6px 31px 0px #0000001F;\n    display: flex;\n    justify-content: center;\n    position: fixed;\n    top: 0;\n    z-index: 9999;\n    background-color: #fff;\n        .navbar-content-wrapper-psp {\n            width: 100%;\n            max-width: 1440px;\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            padding: 0 20px;\n\n            svg{\n                margin: 16px 0;\n            }\n    \n            .navbar-routes-wrapper-psp {\n                display: flex;\n                align-items: center;\n                gap: 40px;\n    \n                a {\n                    font-family: \"Playfair Display\", serif !important;\n                    font-size: 16px;\n                    font-weight: 500;\n                    text-decoration: none;\n                    color: #000;\n                }\n    \n                a:first-child {\n                    display: flex;\n                    align-items: center;\n                    gap: 6px;\n    \n                    svg {\n                        animation: rotate 2s infinite linear;\n                    }\n                }\n            }\n    \n            .navbar-buttons-wrapper-psp {\n                display: flex;\n                align-items: center;\n                gap: 12px;\n    \n                a {\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    padding: 10px 22px;\n                    border-radius: 4px;\n                    font-size: 14px;\n                    font-weight: 700;\n                    text-decoration: none;\n                }\n    \n                a:first-child {\n                    background-color: #93288E;\n                    color: #fff;\n                }\n    \n                a:nth-child(2) {\n                    padding: 9px 22px;\n                    color: #93288E;\n                    border: 2px solid #93288E;\n                }\n    \n                span {\n                    &.disappear {\n                        display: none;\n                    }\n                }\n            }\n        }\n    \n        .navbar-slider-close {\n            transform: translateX(260px);\n        }\n    \n        .navbar-slider-open {\n            transform: translateX(0px);\n        }\n    \n        .navbar-slider {\n            display: none;\n            position: fixed;\n            top: 0;\n            right: 0;\n            bottom: 0;\n            width: 260px;\n            height: 100vh;\n            margin-top: 72px;\n            background-color: #fff;\n            z-index: 9999;\n            box-shadow: 0 0 10px rgba(0, 0, 0, 0.201);\n            transition: transform 0.5s ease-in-out;\n\n            .navbar-routes-wrapper-psp {\n                display: flex;\n                flex-direction: column;\n    \n                a {\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    font-family: \"Playfair Display\", serif !important;\n                    font-size: 16px;\n                    font-weight: 500;\n                    text-decoration: none;\n                    color: #000;\n                    padding: 12px 16px;\n                    &:hover{\n                        background-color: #93288e15;\n                    }\n                }\n    \n                a:first-child {\n                    gap: 6px;\n    \n                    svg {\n                        animation: rotate 2s infinite linear;\n                    }\n                }\n            }\n\n            .navbar-buttons-wrapper-psp {\n                display: flex;\n                flex-direction: column;\n                gap: 12px;\n                margin-top: 16px;\n                padding: 0 16px;\n    \n                a {\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    padding: 10px 22px;\n                    border-radius: 4px;\n                    font-size: 14px;\n                    font-weight: 700;\n                    text-decoration: none;\n                }\n    \n                a:first-child {\n                    background-color: #93288E;\n                    color: #fff;\n                }\n    \n                a:nth-child(2) {\n                    padding: 9px 22px;\n                    color: #93288E;\n                    border: 2px solid #93288E;\n                }\n    \n                span {\n                    &.disappear {\n                        display: none;\n                    }\n                }\n            }\n        }\n    \n        .navbar-slider-overlay {\n            display: none;\n            position: fixed;\n            top: 0;\n            right: 0;\n            bottom: 0;\n            left: 0;\n            width: 100vw;\n            height: 100vh;\n            background-color: rgba(0, 0, 0, 0.5);\n            opacity: 0;\n            z-index: 999;\n            transition: opacity 0.3s ease;\n        }\n}\n\n@keyframes rotate {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  @media only screen and (width <= 1024px) {\n    .navbar-parent-wrapper-psp{\n        .navbar-content-wrapper-psp{    \n            .navbar-routes-wrapper-psp{\n                &.disappear{\n                    display: none;\n                }\n            }\n    \n            .navbar-buttons-wrapper-psp{\n                span{\n                    &.disappear{\n                        display: inline-block;\n                    }\n                }\n            }\n        }\n\n        .navbar-slider {\n            display: inline-block;\n            .navbar-buttons-wrapper-psp {\n                display: none;\n            }\n        }\n\n        .navbar-slider-overlay{\n            &.open{\n                display: block;\n                opacity: 0.5;\n                margin-top: 72px;\n            }\n        }\n    }\n  }\n\n  @media only screen and (width <= 576px) {\n    .navbar-parent-wrapper-psp{\n        .navbar-content-wrapper-psp{    \n            .navbar-buttons-wrapper-psp{\n                a{\n                    &.disappear{\n                        display: none;\n                    }\n                }\n            }\n        }\n\n        .navbar-slider {\n            .navbar-buttons-wrapper-psp {\n                display: flex;\n            }\n        }\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
